const joinClassNames = (...classes) => classes.filter(className => className).join(' ')

export default joinClassNames
